/** Human-readable countdown until an event date (days / weeks / months). */
export function formatCountdown(dateString) {
  if (!dateString) return null;
  const eventDate = new Date(dateString);
  if (Number.isNaN(eventDate.getTime())) return null;
  const now = new Date();
  const diffTime = eventDate - now;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays < 0) {
    const pastDays = Math.abs(diffDays);
    return pastDays === 1 ? 'Past (1 day ago)' : `Past (${pastDays} days ago)`;
  }
  if (diffDays === 0) return 'Today';
  if (diffDays === 1) return 'Tomorrow';
  if (diffDays < 7) return diffDays === 1 ? '1 day' : `${diffDays} days`;
  if (diffDays < 30) {
    const weeks = Math.floor(diffDays / 7);
    return weeks === 1 ? '1 week' : `${weeks} weeks`;
  }
  const months = Math.floor(diffDays / 30);
  return months === 1 ? '1 month' : `${months} months`;
}
